import React from "react";
import { FaDownload } from "react-icons/fa";
import { Box, makeStyles, InputLabel, Typography } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";

const useStyles = makeStyles((theme) => ({
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
}));

const BookTypes = ({ type, upload, setCoverFiles, coverFile }) => {
  const classes = useStyles();

  return (
    <div>
      {type === "all" ? (
        <>
          <Box mb={2}>
            <InputLabel className={classes.fieldLabel}>
              PAPERBACK PDF File
            </InputLabel>
            <DropzoneArea
              onChange={(files) => upload("paperBackCover", files[0])}
              acceptedFiles={["application/pdf"]}
              onDelete={() => setCoverFiles({ ...coverFile, paper_back: "" })}
              filesLimit={1}
              id="pb"
              name="pb"
              inputProps={{
                id: "pb",
                name: "pb",
                required: true,
                style: { display: "inline-block", opacity: 0 },
              }}
              dropzoneText="Upload a single page cover(Front & Back)"
              style={{ maxHeight: 100 }}
            />
            <a href="https://c5m-assets.s3.amazonaws.com/cover-template-prj_6FrVNrxqcWOGNHoXZktUSL%20%281%29-1643628489911.pdf">
              <FaDownload
                color="#ffb203"
                title="Click to download sample"
                size={25}
              ></FaDownload>
            </a>
            <Typography variant="body2" color="error">
              You should download the book pdf cover sample by clicking on the
              icon above. PDF cover size formatting must be according with book
              page count to be approved.
            </Typography>
          </Box>

          <Box mb={2}>
            <InputLabel className={classes.fieldLabel}>
              HARDBACK PDF File
            </InputLabel>
            <DropzoneArea
              onChange={(files) => upload("hardCover", files[0])}
              acceptedFiles={["application/pdf"]}
              onDelete={() => setCoverFiles({ ...coverFile, hard_cover: "" })}
              filesLimit={1}
              id="hb"
              name="hb"
              inputProps={{
                id: "hb",
                name: "hb",
                required: true,
                style: { display: "inline-block", opacity: 0 },
              }}
              dropzoneText="Upload a single page cover(Front & Back)"
              style={{ maxHeight: 100 }}
            />
            <a href="https://c5m-assets.s3.amazonaws.com/cover-template-prj_6FrVNrxqcWOGNHoXZktUSL%20%282%29%20%281%29-1662458577682.pdf">
              <FaDownload
                color="#ffb203"
                title="Click to download sample"
                size={25}
              ></FaDownload>
            </a>
            <Typography variant="body2" color="error">
              You should download the book pdf cover sample by clicking on the
              icon above. PDF cover size formatting must be according with book
              page count to be approved.
            </Typography>
          </Box>
        </>
      ) : type === "paperback" ? (
        <Box mb={2}>
          <InputLabel className={classes.fieldLabel}>
            PAPERBACK PDF File
          </InputLabel>
          <DropzoneArea
            onChange={(files) => upload("paperBackCover", files[0])}
            acceptedFiles={["application/pdf"]}
            onDelete={() => setCoverFiles({ ...coverFile, paper_back: "" })}
            filesLimit={1}
            id="pb"
            name="pb"
            inputProps={{
              id: "pb",
              name: "pb",
              required: true,
              style: { display: "inline-block", opacity: 0 },
            }}
            dropzoneText="Upload a single page cover(Front & Back)"
            style={{ maxHeight: 100 }}
          />
          <a href="https://c5m-assets.s3.amazonaws.com/cover-template-prj_6FrVNrxqcWOGNHoXZktUSL%20%281%29-1643628489911.pdf">
            <FaDownload
              color="#ffb203"
              title="Click to download sample"
              size={25}
            ></FaDownload>
          </a>
          <Typography variant="body2" color="error">
            You should download the book pdf by clicking on the icon above. PDF
            cover size formatting must be according with book page count to be
            approved.
          </Typography>
        </Box>
      ) : type === "hardcover" ? (
        <Box mb={2}>
          <InputLabel className={classes.fieldLabel}>
            HARDBACK PDF File
          </InputLabel>
          <DropzoneArea
            onChange={(files) => upload("hardCover", files[0])}
            acceptedFiles={["application/pdf"]}
            onDelete={() => setCoverFiles({ ...coverFile, hard_cover: "" })}
            filesLimit={1}
            id="hb"
            name="hb"
            inputProps={{
              id: "hb",
              name: "hb",
              required: true,
              style: { display: "inline-block", opacity: 0 },
            }}
            dropzoneText="Upload a single page cover(Front & Back)"
            style={{ maxHeight: 100 }}
          />
          <a href="https://c5m-assets.s3.amazonaws.com/cover-template-prj_6FrVNrxqcWOGNHoXZktUSL%20%282%29%20%281%29-1662458577682.pdf">
            <FaDownload
              color="#ffb203"
              title="Click to download sample"
              size={25}
            ></FaDownload>
          </a>
          <Typography variant="body2" color="error">
            You should download the book pdf by clicking on the icon above. PDF
            cover size formatting must be according with book page count to be
            approved.
          </Typography>
        </Box>
      ) : (
        <></>
      )}
    </div>
  );
};

export default BookTypes;
